import CommonBridge from 'common/CommonBridge';
// 公共的埋点配置 - 信息流
const RecConfig = {
  'Cart.list.recommend.similar': {
    operation: ['TOUCH'],
    title: '信息流看相似按钮点击',
    c: {
      type: 'constant',
      value: 'similar',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
            return traceData.index + 1;
          }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
            return 'next=similar.' + traceData.good.itemId;
          }`,
    },
  },
  'Cart.list.recommend': {
    operation: ['TOUCH'],
    title: '信息流卡片的点击',
    c: {
      type: 'constant',
      value: 'feed',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
            return traceData.index + 1;
          }`,
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const productId = traceData.item.data.goods.itemId;
        return (
          'product_id=' +
          productId +
          '&next=product.' +
          productId +
          '&u=' +
          encodeURIComponent('https://m.mi.com/mfbs/mstd/product?commodityId=' + productId)
        );
      },
    },
  },
};

const getParse_rec_list = {
  type: 'variable',
  func: function (item = {}, visibleData, args) {
    const { scmv2, pageName } = args;
    if (!Array.isArray(item.item) || item.item.length === 0) {
      return [];
    }
    const resultArr = [];
    item.item.forEach((subItem, subInd) => {
      const good = subItem.data.goods;
      const curItem = {
        type: 'rec_list',
        item: subItem,
        isViewable: item.isViewable,
        key: good.itemId,
        index: item.index * 2 + subInd + 1, // d位 Item里面包含2个item
        page: pageName,
        scmv2: scmv2 || subItem.scmv2,
        b: pageName,
        c: 'feed',
        d: item.index * 2 + subInd + 1,
        iid: 'next=product.' + good.itemId,
      };
      const curSimilar = {
        type: 'rec_similar',
        item: subItem,
        isViewable: item.isViewable,
        key: good.itemId,
        index: item.index * 2 + subInd + 1, // d位 Item里面包含2个item
        page: pageName,
        scmv2: scmv2 || subItem.scmv2,
        b: pageName,
        c: 'similar',
        d: item.index * 2 + subInd + 1,
        iid: 'next=product.' + good.itemId,
      };
      resultArr.push(curItem);
      if (!CommonBridge.isWeb()) {
        resultArr.push(curSimilar);
      }
    });
    return resultArr;
  },
};

export { RecConfig, getParse_rec_list };
